import React from 'react';
import { Breadcrumb } from 'semantic-ui-react';
import BreadcrumbItemContent from './BreadcrumbItemContent';

const BreadcrumbItem = ({
  index,
  item,
  length,
  onNavigate,
}) => {
  const isFirst = index === 0;
  const isLast = index === length - 1;
  const isEllipsis = item.ellipsis;
  const withDivider = !isFirst;
  const active = isLast;
  const link = !isLast && !isEllipsis;

  const onClick = index < length - 1 && !isEllipsis
    ? () => onNavigate({ segments: item.segmentLocation })
    : undefined;

  return (
    <>
      {withDivider && <Breadcrumb.Divider />}
      <Breadcrumb.Section active={active} link={link} onClick={onClick}>
        <BreadcrumbItemContent item={item} />
      </Breadcrumb.Section>
    </>
  );
};

export default BreadcrumbItem;
